import PropertyDiscussionPage from "../../propertyNew/PropertyDiscussionPage";

const PropertyDiscussionDetail = ({ backPath = "/customer/properties" }) => {
  return <PropertyDiscussionPage back={backPath} />;
};

export default PropertyDiscussionDetail;
